import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResult } from './confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: ConfirmDialogData) {
    return this.dialog.open<ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResult>(
      ConfirmDialogComponent,
      {
        width: '30rem',
        maxWidth: 'calc(100vw - 1.5rem)',
        autoFocus: false,
        restoreFocus: false,
        panelClass: 'bgf-confirm-dialog-panel',
        backdropClass: 'bgf-confirm-dialog-backdrop',
        data,
      },
    ).afterClosed();
  }
}
